namespace TabAurous.Production {
    export interface MFGTransactionRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        ItemDetails?: MFGTransactionItemsRow[];
    }

    export namespace MFGTransactionRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.MFGTransaction';
        export const deletePermission = 'Production:MFGTransaction:Delete';
        export const insertPermission = 'Production:MFGTransaction:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:MFGTransaction:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            ItemDetails = "ItemDetails"
        }
    }
}
